<div class="my-tasks">

    <div class="side-nav-panel-content my-tasks-scroll">

      <app-loading-screen *ngIf="loading"></app-loading-screen>

      <div *ngIf="noDriverTasks"><h3>No Assigned Tasks</h3></div>

      <ng-container *ngFor="let data of driverTasks; let i=index" >
<!--
Inbound/Outbound Flight Task
-->
        <div class="panel-container"  *ngIf="data.typeName ==='InboundFlight' || data.typeName ==='OutboundFlight'">
          <button mat-button (click)="panel.toggle()" class="toggle-button">
            <mat-icon [ngClass]="{'is-open': panel.expanded}">navigate_next</mat-icon>
          </button>
          <mat-expansion-panel [expanded]="data.taskName==expandedPanel"
           (opened)="setExpandedpanel(data)" hideToggle disabled #panel class="expansion-panel"
           (closed)="expandedPanel = data.taskName === expandedPanel ? '0' : expandedPanel">
            <mat-expansion-panel-header (click)="panel.toggle()">
              <mat-panel-description>
                <div class="header">
                  <div>{{data.displayName}}</div>
                  <div>{{data.parkingPosition}}</div>
                  <div>{{data.tailNumber}}</div>
                  <div class="flight-status">
                    <span>{{data.typeName === 'InboundFlight' ? data.origin : data.destination}}</span>
                    <mat-icon [ngClass]="{'downwards':data.typeName ==='InboundFlight', 'upwards': data.typeName ==='OutboundFlight'}">flight</mat-icon>
                    <span class="outOffOnInText" *ngIf="data.typeName ==='InboundFlight'">{{data.actualOnTime && !data.actualInTime ? '(ON)' : ''}} {{data.actualInTime ? '(IN)' : ''}}</span>
                    <span class="outOffOnInText" *ngIf="data.typeName ==='OutboundFlight'">{{data.actualOutTime && !data.actualOffTime ? '(OUT)' : ''}} {{data.actualOffTime ? '(OFF)' : ''}}</span>
                  </div>
                </div>
                <div class="customsIconDiv">
                  <div *ngIf="checkCustoms(data.origin)">C</div>
                </div>
                <div class="time-status due"
                [ngClass]="{'due': time[0] ==='EARLY', 'overdue': time[0] ==='LATE', 'actual-on-time': data.actualOnTime !== null && data.actualInTime === null}" *ngIf="getdueTime(data.arrivalTime); let time">
                    <div class="time">{{time[0] === 'LATE' ? '-' : ''}}{{time[1]}}</div>
                    <div class="unit">{{time[2]}}</div>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <form [formGroup]="driverTasksForm" fxLayout class="content-area">
              <div class="time-section">
                <div>
                  <div class="time-header">CPL</div>
                  <div>
                    {{ data.actualEnd !== null && data.actualEnd !== 'Invalid date' && data.actualEnd !== '' ? (data.actualEnd | momentFormat : 'H:mm') : '--' }}
                  </div>
                </div>
                <div>
                  <div class="time-header">{{data.typeName === 'InboundFlight' ? 'STA' : 'STD'}}</div>
                  <div>{{data.typeName === 'InboundFlight' ? data.scheduledArrivalTime || '--' : data.scheduledDepartureTime || '--'}}</div>
                </div>
                <div>
                  <div class="time-header">{{data.typeName === 'InboundFlight' ? 'ETA' : 'ETD'}}</div>
                  <div>{{data.typeName === 'InboundFlight' ? data.estimatedArrivalTime || '--' : data.estimatedDepartureTime ||  data.scheduledDepartureTime || '--'}}</div>
                </div>
                <div>
                  <div class="time-header">{{data.typeName === 'InboundFlight' ? 'ON' : 'OUT'}}</div>
                  <div>{{data.typeName === 'InboundFlight' ? data.actualOnTime || '--' : data.actualOutTime || '--'}}</div>
                </div>
                <div>
                  <div class="time-header">{{data.typeName === 'InboundFlight' ? 'IN' : 'OFF'}}</div>
                  <div>{{data.typeName === 'InboundFlight' ? data.actualInTime || '--' : data.actualOffTime || '--'}}</div>
                </div>
              </div>

              <div class="add-item-section">

                <div *ngFor="let person of data.passengers">
                  <div class="item-rows" flex>
                    <div class="item cpt" >
                      <div class="first-label-column">
                        <mat-label>{{person.role}}</mat-label>
                      </div>
                      <div class="name-column">
                        <mat-label>{{person | passengerNameFormat}}</mat-label>
                      </div>
                      <div class="toggle-column">
                        <mat-slide-toggle
                          color="primary"
                          [formControl]="getPassengerFormControl(data.taskName, person.id, data.status)"
                          [checked]="pickUpDropOffAll === true"
                          (change)="passengerOnChange($event, person)">
                        </mat-slide-toggle>
                      </div>
                      <div class="type-icon-column">
                        <mat-icon class="icon-user-switch" svgIcon="icon-user"  aria-hidden="true"></mat-icon>
                      </div>
                      <div class="warning-icon-column">
                        <fa-icon class="alertDarkMode" *ngIf="!person.checkedIn" [icon]="warningIcon" style="color: orange;"></fa-icon>
                      </div>
                      <div class="trash-button-column">
                        <button mat-raised-button [ngStyle]="{'float':'right'}" disabled >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div *ngFor="let detail of data.addOnDetails">
                    <div class="item-rows" flex>
                      <div class="item cpt">
                        <div class="first-label-column">
                          <mat-label>{{detail.type}}</mat-label>
                        </div>
                        <div class="name-column">
                          <mat-label>{{detail.name}}</mat-label>
                        </div>
                        <div class="toggle-column">
                          <mat-slide-toggle
                          color="primary"
                            [formControl]="getDetailsFormControl(data.taskName, data.status, detail.id)"
                            [checked]="pickUpDropOffAll === true">
                          </mat-slide-toggle>
                        </div>
                        <div class="type-icon-column">
                          <mat-icon *ngIf="detail.type === 'Passenger' || detail.type === 'JS' || detail.type === 'FO' || detail.type === 'CPT'" class="icon-user-switch" svgIcon="icon-user"  aria-hidden="true"></mat-icon>
                          <mat-icon *ngIf="detail.type === 'Other'" class="icon-tasks-switch" svgIcon="icon-tasks"  aria-hidden="true"></mat-icon>
                          <mat-icon *ngIf="detail.type === 'Catering'" class="icon-cutlery-switch" svgIcon="icon-catering"  aria-hidden="true"></mat-icon>
                          <mat-icon *ngIf="detail.type === 'Paperwork' || detail.type === 'Customs'" class="icon-file-switch" svgIcon="icon-file"  aria-hidden="true"></mat-icon>
                        </div>
                        <div class="warning-icon-column">
                          &nbsp;
                        </div>
                        <div class="trash-button-column">
                          <button mat-raised-button [ngStyle]="{'float':'right'}" (click)="onRemoveTaskDetails(data.taskName, detail.id)"><mat-icon>delete</mat-icon></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div  class="item-rows dynamic-addon-row" flex>
                  <div *ngIf="showAdd" class="item" [ngStyle]="{'display': 'flex'}">
                    <div>
                      <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select panelWidth="" placeholder="Select"  #rowType >
                          <mat-option *ngFor="let type of addItemTypes" [value]="type.value">{{type.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <input matInput #rowValue />
                      </mat-form-field>
                    </div>
                    <div>
                      <button type="button" [disabled]="rowType.value === undefined" mat-raised-button color="primary" (click)="populateAndAddTaskDetails(data.taskName, rowType.value, rowValue.value, $event)">Add +</button>
                    </div>
                    <div>
                      <button mat-raised-button [ngStyle]="{'float':'right'}" (click)="toggleAddItem(false)"><mat-icon>delete</mat-icon></button>
                    </div>
                  </div>
                  <button mat-icon-button aria-label="Add Pickup Details" class="add-pickup-button"  (click)="toggleAddItem(true)">
                    <mat-icon>add_circle</mat-icon>
                  </button>
                </div>
              </div>

              <div class="notes-section">
                <div>
                  <mat-label>Coord. Notes:</mat-label>
                  <textarea matInput class="form-control" rows="4" formControlName="cordNotes" readonly></textarea>
                </div>
                <div>
                  <mat-label>Driver Notes:</mat-label>
                  <textarea matInput class="form-control" rows="4" formControlName="driverNotes"></textarea>
                </div>
              </div>
              <div  class="assign-task">
              <!-- pickup buttons -->
                <div *ngIf="showPickUpButtons(data.status)" class="form-button-rows-wrap">
                  <button type="button"
                  class="pickup-all-button" mat-raised-button
                  (click)="pickup(data, PickUpDropOffType.PICKUP_ALL)"
                  [disabled]="currentTaskToProcess === data.taskName">
                    <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Pickup All '}}</span>
                    <mat-icon iconPositionEnd class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                  </button>

                  <button type="button"
                  class="pickup-selected-button" mat-raised-button
                  (click)="pickup(data, PickUpDropOffType.PICKUP_SELECTED)"
                  [disabled]="driverTasksForm.pristine || currentTaskToProcess === data.taskName" >
                    <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Pickup Selected '}}</span>
                    <mat-icon iconPositionEnd class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                  </button>
                </div>
              <!-- dropoff buttons -->
                <div *ngIf="showDropOffButtons(data.status)" class="form-button-rows-wrap">
                  <button type="button"
                  class="dropoff-all-button" mat-raised-button
                  (click)="dropoff(data, PickUpDropOffType.DROPOFF_ALL)"
                  [disabled]="currentTaskToProcess === data.taskName" >
                    <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Dropoff All '}}</span>
                    <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                  </button>

                  <button type="button"
                  class="dropoff-selected-button" mat-raised-button
                  (click)="dropoff(data, PickUpDropOffType.DROPOFF_SELECTED)"
                  [disabled]="driverTasksForm.pristine || currentTaskToProcess === data.taskName" >
                    <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Dropoff Selected '}}</span>
                    <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
                  </button>
                </div>

              <!-- unassign button -->
                <div *ngIf="canUnassignTask(data)" class="form-button-rows-wrap">
                  <button type="button" class="unassign-button" mat-raised-button (click)="onUnassignTask(data.taskName)"
                    [disabled]="currentTaskToProcess === data.taskName">
                    <span>
                      {{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Unassign Task '}}
                    </span>
                    <i class="icon-minus-circle-white-inline minus-icon"></i>
                  </button>
                </div>

              </div>
            </form>
          </mat-expansion-panel>
        </div>
<!--
Remote Parking Task
-->
        <div class="panel-container"  *ngIf="data.typeName === 'RemoteParking'">
          <button mat-button (click)="panel1.toggle()" class="toggle-button">
            <mat-icon [ngClass]="{'is-open': panel1.expanded}">navigate_next</mat-icon>
          </button>
          <mat-expansion-panel [expanded]="data.taskName==expandedPanel"
          (opened)="setExpandedpanel(data)" hideToggle disabled #panel1 class="expansion-panel" (closed)="expandedPanel = data.taskName === expandedPanel ? '0' : expandedPanel">
           <mat-expansion-panel-header (click)="panel1.toggle()">
             <mat-panel-description>
              <div class="header">
                <div>{{data.displayName}}</div>
                <div></div>
                <div>{{data.plannedStart | date: 'HH:mm' || ''}} - {{data.plannedEnd | date: 'HH:mm' || ''}}</div>
                <div class="flight-status"></div>
              </div>
              <div class="customsIconDiv">
                <div></div>
              </div>
              <div class="minutesBorderBoxDiv" *ngIf="getdueTime(data.plannedEnd); let time">
                <div [ngClass]="time[0] ==='EARLY' ? 'minWrap' :'minWrapLate'">
                  <div [ngClass]="time[0] ==='EARLY' ? 'minutesStyle' :'lateMinutesStyle'">
                    <div class="time">{{time[0] === 'LATE' ? '-' : ''}}{{time[1]}}</div>
                    <div class="unit"><span class="minutesTxt">{{time[2]}}</span></div>
                  </div>
              </div>
             </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
            <form  [formGroup]="driverTasksForm" fxLayout class="content-area">
              <div class="row taskRemoteParkingDetails taskDetails" style="display: block;">
                <div class="row leaveASCButtonRow">
                  <div class="col-12" style="text-align:center">
                    <button (click)="departASCEdgewood(data.taskName, 'depart-asc')"
                      type="button"
                      [ngClass]="data.departStation === 'depart-asc' ? 'alert-warning' : 'btn-info'"
                      class="btn leaveASCButton"
                      [disabled]="currentTaskToProcess === data.taskName">
                      {{currentTaskToProcess === data.taskName ? 'Please Wait... ' : 'Leave ASC '}} &nbsp;&nbsp;&nbsp;&nbsp;<span class="icon-ASC1"></span>
                    </button>
                  </div>
                </div>
                <div class="row leaveEdgewoodButtonRow">
                  <div class="col-12" style="text-align:center; margin-bottom:10px;">
                    <button (click)="departASCEdgewood(data.taskName, 'depart-edgewood')"
                      type="button"
                      [ngClass]="data.departStation === 'depart-edgewood' || data.departStation === null ? 'alert-warning' : 'btn-info'"
                      class="btn leaveEdgewoodButton"
                      [disabled]="currentTaskToProcess === data.taskName">
                      {{currentTaskToProcess === data.taskName ? 'Please Wait... ' : 'Leave Edgewood '}} &nbsp;&nbsp;<span class="icon-parking"></span>
                    </button>
                  </div>
                </div>
                <div class="notes-section">
                  <div>
                    <mat-label>Coordinator Notes:</mat-label>
                    <textarea matInput formControlName="cordNotes" class="form-control" readonly rows="4"></textarea>
                  </div>
                  <div>
                    <mat-label>Driver Notes:</mat-label>
                    <textarea matInput formControlName="driverNotes" class="form-control" rows="4"></textarea>
                  </div>
                </div>
                <!-- <div class="row remoteParkingNotesRow outerNotesWrapper" style="margin-right:0; margin-left:0">
                  <div class="coordNotesMainWrapper col-6">
                    <div class="coordNotesheader">Coord. Notes:</div>
                    <div class="coordNotes">
                        {{data.specialInstructions}}
                    </div>
                  </div>
                  <div class="driverNotesMainWrapper col-6">
                    <div class="driverNotesHeader">Driver Notes:</div>
                    <div class="driverNotes">
                        {{data.driverNotes === 'null' ? '' : data.driverNotes}}
                    </div>
                  </div>
                </div> -->

                <div class="assignTaskButtonRow">
                  <button *ngIf="canEndTask(data)"
                  class="unassign-button"
                  type="button" mat-raised-button
                  (click)="endTask(data)"
                  [disabled]="currentTaskToProcess === data.taskName">
                    <span>
                      {{currentTaskToProcess === data.taskName ? 'Processing... ' : 'End Task '}}
                    </span>
                     <mat-icon>playlist_add</mat-icon>
                  </button>

                  <button *ngIf="canDeleteTask(data)"
                  type="button" mat-raised-button
                  class="unassign-button"
                  (click)="onEndOrDeleteTaskNow(data.taskName, 'deleteTask')"
                  [disabled]="currentTaskToProcess === data.taskName">
                    <span>
                      {{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Delete Task '}}
                    </span>
                     <mat-icon>playlist_add</mat-icon>
                  </button>

                </div>
              </div>
            </form>
          </mat-expansion-panel>
        </div>
<!--
Adhoc Task
-->
<div class="panel-container"  *ngIf="data.typeName === 'Other'">
  <button mat-button (click)="panel2.toggle()" class="toggle-button">
    <mat-icon [ngClass]="{'is-open': panel2.expanded}">navigate_next</mat-icon>
  </button>
  <mat-expansion-panel [expanded]="data.taskName==expandedPanel"
  (opened)="setExpandedpanel(data)" hideToggle disabled #panel2 class="expansion-panel" (closed)="expandedPanel = data.taskName === expandedPanel ? '0' : expandedPanel">
   <mat-expansion-panel-header (click)="panel2.toggle()">
     <mat-panel-description>
      <div class="header">
        <div>{{data.displayName}}</div>
        <div>{{data.pickupLocation || '--'}}</div>
        <div>{{data.plannedStart | date: 'HH:mm' || ''}} - {{data.plannedEnd | date: 'HH:mm' || ''}}</div>
        <div class="flight-status">{{data.dropOffLocation || '--'}}</div>
      </div>
      <div class="customsIconDiv">
        <div></div>
      </div>
      <div class="minutesBorderBoxDiv" *ngIf="getdueTime(data.plannedEnd); let time">
        <div [ngClass]="time[0] ==='EARLY' ? 'minWrap' :'minWrapLate'">
          <div [ngClass]="time[0] ==='EARLY' ? 'minutesStyle' :'lateMinutesStyle'">
            <div class="time">{{time[0] === 'LATE' ? '-' : ''}}{{time[1]}}</div>
            <div class="unit"><span class="minutesTxt">{{time[2]}}</span></div>
          </div>
      </div>
     </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
    <form [formGroup]="driverTasksForm" fxLayout class="content-area">
      <div class="add-item-section">
        <div>
          <div *ngFor="let detail of data.addOnDetails">
            <div class="item-rows" flex>

              <div class="item cpt">
                <div class="first-label-column">
                  <mat-label>{{detail.type}}</mat-label>
                </div>
                <div class="name-column">
                  <mat-label>{{detail.name}}</mat-label>
                </div>
                <div class="toggle-column">
                  <mat-slide-toggle color="primary" [formControl]="getDetailsFormControl(data.taskName, data.status, detail.id)"></mat-slide-toggle>
                </div>
                <div class="type-icon-column">
                  <mat-icon *ngIf="detail.type === 'Passenger' || detail.type === 'JS' || detail.type === 'FO' || detail.type === 'CPT'" class="icon-user-switch" svgIcon="icon-user"  aria-hidden="true"></mat-icon>
                  <mat-icon *ngIf="detail.type === 'Other'" class="icon-tasks-switch" svgIcon="icon-tasks"  aria-hidden="true"></mat-icon>
                  <mat-icon *ngIf="detail.type === 'Catering'" class="icon-cutlery-switch" svgIcon="icon-catering"  aria-hidden="true"></mat-icon>
                  <mat-icon *ngIf="detail.type === 'Paperwork' || detail.type === 'Customs'" class="icon-file-switch" svgIcon="icon-file"  aria-hidden="true"></mat-icon>
                </div>
                <div class="warning-icon-column">
                  &nbsp;
                </div>
                <div class="trash-button-column">
                  <button mat-raised-button [ngStyle]="{'float':'right'}" (click)="onRemoveTaskDetails(data.taskName, detail.id)"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div  class="item-rows dynamic-addon-row" flex>
          <div *ngIf="showAdd" class="item" [ngStyle]="{'display': 'flex'}">
            <div>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select placeholder="Select"  #rowType >
                  <mat-option *ngFor="let type of addItemTypes" [value]="type.value">{{type.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <input matInput #rowValue [disabled]="rowType.value === undefined"/>
              </mat-form-field>
            </div>
            <div>
              <button type="button" [disabled]="rowValue.value === ''" mat-raised-button color="primary" (click)="populateAndAddTaskDetails(data.taskName, rowType.value, rowValue.value, $event)">Add +</button>
            </div>
            <div>
              <button mat-raised-button [ngStyle]="{'float':'right'}"  (click)="toggleAddItem(false)"><mat-icon>delete</mat-icon></button>
            </div>
          </div>
          <button mat-icon-button aria-label="Add Pickup Details" class="add-pickup-button"  (click)="toggleAddItem(true)">
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
        </div>
      <div class="notes-section">
        <div>
          <mat-label>Coordinator Notes:</mat-label>
          <textarea matInput formControlName="cordNotes" class="form-control" readonly rows="4"></textarea>
        </div>
        <div>
          <mat-label>Driver Notes:</mat-label>
          <textarea matInput formControlName="driverNotes" class="form-control" rows="4"></textarea>
        </div>
      </div>
      <div class="assign-task">
        <div class="form-button-rows-wrap" *ngIf="showPickUpButtons(data.status)">

          <button type="button"
          class="pickup-all-button" mat-raised-button
          (click)="pickup(data, PickUpDropOffType.PICKUP_ALL)"
          [disabled]="currentTaskToProcess === data.taskName">
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Pickup All '}}</span>
            <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
          </button>

          <button type="button"
          class="pickup-selected-button" mat-raised-button
          (click)="pickup(data, PickUpDropOffType.PICKUP_SELECTED)"
          [disabled]="driverTasksForm.pristine || currentTaskToProcess === data.taskName">
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Pickup Selected '}}</span>
            <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
          </button>
        </div>

        <div class="form-button-rows-wrap" *ngIf="showDropOffButtons(data.status)">

          <button type="button"
          class="dropoff-all-button" mat-raised-button
          (click)="dropoff(data, PickUpDropOffType.DROPOFF_ALL)"
          [disabled]="currentTaskToProcess === data.taskName" >
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Dropoff All '}}</span>
            <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
          </button>

          <button type="button"
          class="dropoff-selected-button" mat-raised-button
          (click)="dropoff(data, PickUpDropOffType.DROPOFF_SELECTED)"
          [disabled]="driverTasksForm.pristine || currentTaskToProcess === data.taskName" >
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Dropoff Selected '}}</span>
            <mat-icon class="material-icons-outlined" svgIcon="icon-user"></mat-icon>
          </button>
        </div>

        <div class="assignTaskButtonRow">
          <button *ngIf="canEndTask(data)" class="unassign-button" type="button" mat-raised-button
            (click)="onEndTask(data)" [disabled]="currentTaskToProcess === data.taskName">
              <span>
                {{currentTaskToProcess === data.taskName ? 'Processing... ' : 'End Task '}}
              </span>
              <mat-icon>playlist_add</mat-icon>
          </button>
        </div>

        <div class="form-button-rows-wrap">
          <!-- <button *ngIf="canUnassignTask(data)"
          type="button"
          class="unassign-button" mat-raised-button
          (click)="onUnassignTask(data.taskName)"
          [disabled]="currentTaskToProcess === data.taskName" >
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Unassign Task '}}</span>
            <i class="icon-minus-circle-white-inline minus-icon"></i>
          </button> -->
          <button *ngIf="canDeleteTask(data)"
          type="button"
          class="unassign-button" mat-raised-button
          (click)="onEndOrDeleteTaskNow(data.taskName, 'deleteTask')"
          [disabled]="currentTaskToProcess === data.taskName">
            <span>{{currentTaskToProcess === data.taskName ? 'Processing... ' : 'Delete Task '}}</span>
            <i class="icon-minus-circle-white-inline minus-icon"></i>
          </button>
        </div>

    </div>
    </form>
  </mat-expansion-panel>
</div>
<!--
Terminal Task
-->
        <div class="panel-container"  *ngIf="data.typeName === 'Terminal'">
          <button mat-button (click)="panel3.toggle()" class="toggle-button">
            <mat-icon [ngClass]="{'is-open': panel3.expanded}">navigate_next</mat-icon>
          </button>
          <mat-expansion-panel [expanded]="data.taskName==expandedPanel"
          (opened)="setExpandedpanel(data)" hideToggle disabled #panel3 class="expansion-panel" (closed)="expandedPanel = data.taskName === expandedPanel ? '0' : expandedPanel">
           <mat-expansion-panel-header (click)="panel3.toggle()">
             <mat-panel-description>
              <div class="header">
                <div>{{data.displayName}}</div>
                <div></div>
                <div>{{data.plannedStart | date: 'HH:mm' || ''}} - {{data.plannedEnd | date: 'HH:mm' || ''}}</div>
                <div class="flight-status"></div>
              </div>
              <div class="customsIconDiv">
                <div></div>
              </div>
              <div class="minutesBorderBoxDiv" *ngIf="getdueTime(data.plannedEnd); let time">
                <div [ngClass]="time[0] ==='EARLY' ? 'minWrap' :'minWrapLate'">
                  <div [ngClass]="time[0] ==='EARLY' ? 'minutesStyle' :'lateMinutesStyle'">
                    <div class="time">{{time[0] === 'LATE' ? '-' : ''}}{{time[1]}}</div>
                    <div class="unit"><span class="minutesTxt">{{time[2]}}</span></div>
                  </div>
              </div>
             </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <form fxLayout class="content-area">
            <app-terminal-run-details [task]="data" [mode]="'MyTasks'" (updateTask)="updateTasks()"
              (deleteTask)="onEndOrDeleteTaskNow(data.taskName, 'deleteTask')" (endTask)="onEndTask(data)"
              (unassignTask)="onUnassignTask(data.taskName)"></app-terminal-run-details>
          </form>
          </mat-expansion-panel>
        </div>


      </ng-container>
    </div>




















































</div>
